import { useState, useCallback } from "react";
import { GetUserData } from "common/service/CommonService";

export type ScanningActivityType = "sample_collection" | "dosing";

export const useClinicalActivity = (
  onSelectActivity: (activity: ScanningActivityType) => void
) => {
  const [selected, setSelected] = useState<ScanningActivityType | null>(null);
  const user = GetUserData();

  const rawName = user?.firstname || user?.username;
  const userName = typeof rawName === "string" ? rawName : "Investigator";

  const handleChooseActivity = useCallback(
    (activity: ScanningActivityType) => {
      setSelected(activity);
      onSelectActivity(activity);
    },
    [onSelectActivity]
  );

  return {
    selected,
    userName,
    handleChooseActivity,
  };
};
